import { useLocalization } from "@/context/localization-context";
import { usePermissions } from "@/hooks/use-permissions";
import AdminDashboard from "./admin/page";
import BranchDashboard from "./branch/page";

export default function Page() {
  const { hasPermission } = usePermissions();
  const { t } = useLocalization();

  // Admin users have full dashboard access (no branch restriction)
  const isAdminDashboard = hasPermission("dashboard");
  
  // Branch owners have dashboard access but limited to their branch
  const isBranchDashboard = hasPermission("dashboard.branch") && !hasPermission("dashboard");

  // Route to appropriate dashboard based on permissions
  if (isAdminDashboard) {
    return <AdminDashboard />;
  }
  
  if (isBranchDashboard) {
    return <BranchDashboard />;
  }

  // Fallback for users without dashboard permissions
  return (
    <div className="flex flex-1 items-center justify-center">
      <div className="text-center">
        <h2 className="text-xl font-semibold text-foreground">{t("dashboard.accessDeniedTitle")}</h2>
        <p className="text-muted-foreground">{t("dashboard.accessDeniedDescription")}</p>
      </div>
    </div>
  );
}
